import {useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {app} from "../../modules/config.ts";

// 메인 스타일 시트가 로딩되기전 페이지 틀어짐 방지용
import "./splash.css";

function PageSplash() {
  const navigate = useNavigate();
  const logoRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    setTimeout(function () {
      logoRef.current?.classList.add("show");
      setTimeout(() => {
        navigate('/login');
      }, 1000);
    }, 2000);
  }, [navigate]);
  return (
    <div className="container">
      <div className="splash">
        <img src={`${app.imagePath}/favicon.png`} alt="로고" className="splash-logo" ref={logoRef} />
      </div>
    </div>
  );
}

export default PageSplash;